import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { eSalaryGet } from "../../api";
import { IconMoney } from "../../common/icons";
import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { jsError } from "../../common/utils";


export function PayrollStatus() {
  const { t } = useTranslation();
  const [data, setData] = useState();

  useEffect(() => {
    (async () => {
      try {
        const res = await eSalaryGet("payrollstatus");
        setData(res.data.payrollstatus[0]);
      } catch (err) {
        jsError(err);
      }
    })();
  }, []);

  return data
    ?
    <Row className="gap-3">
      <h4 style={{color: "var(--heeros-blue)"}}>{t("PayrollStatus", "Palkkakauden tiedot")}</h4>
      <Col className="flex-grow-0"><IconMoney size="53" /></Col>
      <Col>
        <p>{t("CurrentPeriod", "Kuluva kausi")}: <b>{data.currentperiodname}</b></p>
        <p>{t("PayDate", "Maksupäivämäärä")}: <b>{data.currentperiodpaydate}</b></p>
        <b>{data.currentperiodstatus === "1" ? "" : data.currentperiodstatus}</b>
      </Col>
    </Row>
    : <LoadingContainer />;
}
